import type { FaireProductEntity } from "../../entity_types/product";

export const p_tz5hcwm9p5: FaireProductEntity = {
  token: "p_tz5hcwm9p5",
  type: "product",
  name: "Mahjong Is My Therapy Kitchen Towel",
  brandToken: "b_vrn6ys29wd",
  brandName: "Absorb-Lumen",
  imageUrl:
    "https://cdn.faire.com/fastly/e5bf7b21018b023bc75d8d877e06c22f77cf9d905784afbc62967b1c24244ce5.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/944ea8eaa919ad33a7dd4c3a328c429d2a979f018fcc3d7181224f2d9333d829.png",
  ],
  priceDollars: 9,
  description:
    "Because some things just bring peace.\n\nOur Mahjong Is My Therapy Kitchen Towel pairs a beautiful, intricate floral design with a sentiment every mahjong lover understands. It is the perfect blend of calm, connection, and a little bit of fun.\n\nMade from our signature recycled microfiber, this towel is designed for real life. It absorbs up to 7 times its weight and dries quickly, making it as functional as it is beautiful.\n",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:39.655Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
